import { UtilityService } from '@eforall/common';
import { buildColumn, GridColumn } from '@eforall/dashboard';
import { AIPromptAndResponseWithUpdatedUTC } from '@interfaces';


export function getColumns(util: UtilityService) {


	const columns: GridColumn<AIPromptAndResponseWithUpdatedUTC, unknown>[] = [
		buildColumn(util, 'Id', row => row.aiPromptId, { header: 'aiPromptId' }),
		buildColumn(util, 'Id', row => row.personId, { header: 'personId' }),
		buildColumn(util, 'Id', row => row.accVentureId, { header: 'accVentureId' }),
		buildColumn(util, 'Text', row => row.personFullName, { header: 'Name', hidden: true }),
		buildColumn(util, 'Text', row => row.ventureName, { header: 'Venture', hidden: true }),
		buildColumn(util, 'Text', row => row.userRolePhase, { header: 'Phase' }),
		buildColumn(util, 'Text', row => row.promptType, { header: 'Type' }),
		buildColumn(util, 'Text', row => row.promptAuthor, { header: 'Author' }),
		buildColumn(util, 'Text', row => row.responseDetails?.languageDetected, { header: 'Language Detected' }),
		buildColumn(util, 'Text', row => row.responseDetails?.topicDetected, { header: 'Topic Detected' }),
		buildColumn(util, 'Text', row => row.responseDetails?.intentDetected, { header: 'Intent Detected' }),
		buildColumn(util, 'YesNo', row => row.responseDetails?.isPromptEntrepreneurial, { header: 'Entrepreneurial', hidden: true }),
		buildColumn(util, 'Text', row => row.responseDetails?.rating, { header: 'Rating' }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.updatedUTC), { header: 'Date', hidden: true }),
	];

	return columns;

}
